export default class Actions {
	constructor(callback) {
		this.callback = callback;
	}

	init() {
		this.mc = jQuery("#template-actions").clone();
		this.mc.attr("id", "action" + Actions.ENUM++);
		jQuery(".js-play", this.mc).hide();

		this.setButtons();
		jQuery(".js-3x1010", this.mc).on("click", this.goto3x1010.bind(this));
		this.initShare();

	}
	getClip() {
		return this.mc;
	}

	goto3x1010() {
		window.open("https://www.3x1010.it", "_blank");
	}


	setButtons() {
		let images = Actions.BUTTONS;
		for (let x = 0; x < images.length; x++) {
			let el = images[x];
			jQuery(".js-pict ", jQuery(el[0], this.mc)).css("background-image", "url('" + el[1] + "')");
			if (el[0] !== ".js-share") {
				jQuery(el[0], this.mc).on("click", this.clicked.bind(this, el[2]))
			} else {
				jQuery(el[0], this.mc).on("click", this.toggleShare.bind(this))
			}
		}
		this.enable(Actions.PAUSE, false);

	}

	clicked(which) {
		this.dispatch({ type: Actions.EVENT_CLICKED, data: { which: which } });
		if (which == Actions.PAUSE) {
			jQuery(".js-pause", this.mc).hide();
			jQuery(".js-play", this.mc).show();
		}
		if (which == Actions.PLAY) {
			jQuery(".js-pause", this.mc).show();
			jQuery(".js-play", this.mc).hide();
		}
	}

	enable(action, lFlag) {
		let a = Actions.BUTTONS;
		for (let x = 0; x < a.length; x++) {
			if (a[x][2] === action) {
				if (lFlag) {
					jQuery(a[x][0], this.mc).removeClass("action-button-disabled");
				} else {
					jQuery(a[x][0], this.mc).addClass("action-button-disabled");
				}
			}
		}

	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	destroy() {

	}

	trigger(action) {
		let a = Actions.BUTTONS;
		for (let x = 0; x < a.length; x++) {
			if (a[x][2] === action) {
				jQuery(a[x][0], this.mc).trigger("click");
			}
		}


	}

	initShare() {
		var shares = [
			{
				share: "pinterest",
				logo: `./assets/misc/share_p.png`,
				label: "Share on Pinterest"
			}, {
				share: "twitter",
				logo: `./assets/misc/share_t.png`,
				label: "Share on Twitter"
			}, {
				share: "facebook",
				logo: `./assets/misc/share_f.png`,
				label: "Share on Facebook"
			}
		];

		this.mc.find(".share-container").jsSocials({
			
			url: document.location.href,
			shareIn: "popup",
			showLabel: false,
			shares,
			on: {
				click: function (e) {
					//console.log("SUCA")
					//let a = e.target.classList;
					//let soc = (a[1].split("-"))[1];
					/*const event = new Event("click");
					jQuery(".js-btn-condividi", this.mc).get(0).dispatchEvent(event);*/
				}
			}
		});

		this.mc.find(".share-container").hide();


	}

	toggleShare() {
		let clip = this.mc.find(".share-container");
		if (clip.is(":visible")) {
			jQuery(".js-3x1010").show();
			clip.hide();
		} else {
			jQuery(".js-3x1010").hide();
			clip.show();
		}
	}


}
Actions.ENUM = 0;
Actions.PAUSE = "pause";
Actions.PLAY = "play";
Actions.REARRANGE = "rearrange";
Actions.INFO = "info";
Actions.SHARE = "share";
Actions.SETTINGS = "settings";
Actions.EXIT = "exit";


Actions.EVENT_CLICKED = "eventClicked"

Actions.BUTTONS = [
	[".js-pause", "./assets/ui/btn_pause.png", Actions.PAUSE],
	[".js-play", "./assets/ui/btn_play.png", Actions.PLAY],
	[".js-rearrange", "./assets/ui/btn_rearrange.png", Actions.REARRANGE],
	[".js-info", "./assets/ui/btn_info.png", Actions.INFO],
	[".js-share", "./assets/ui/btn_share.png", Actions.SHARE],
	[".js-settings", "./assets/ui/btn_settings.png", Actions.SETTINGS],
	[".js-exit", "./assets/ui/btn_exit.png", Actions.EXIT]
]
